module.exports = __webpack_public_path__ + "img/scan-success-illustration.13316298.svg";